export default "__VITE_ASSET__yCBGDcSC__"